import {
  applyMiddleware,
  compose,
  createStore,
  Store,
  Reducer,
  ReducersMapObject
} from 'redux'
import { routerMiddleware } from 'react-router-redux'
import { History } from 'history'
import { googleAnalytics } from '../analytics/middleware'
import thunk from 'redux-thunk'

import createReducer, { Store as AppStore } from '../reducers/'
import { getDefaultSpaceType } from '../location_changes/conversionHelper'

declare global {
  interface Window {
    // tslint:disable-next-line
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any
  }
}

window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || {}

interface AsyncStore<S> extends Store<S> {
  asyncReducers: ReducersMapObject
}

export function injectAsyncReducer(
  store: AsyncStore<AppStore.Complete>,
  name: string,
  asyncReducer: Reducer<any> // tslint:disable-line
) {
  if (!store.asyncReducers[name]) {
    store.asyncReducers[name] = asyncReducer
    store.replaceReducer(createReducer(store.asyncReducers))
  }
}

const locationStorage = store => next => action => {
  if (action.type === 'SELECT_COUNTRY') {
    window.localStorage.setItem('peikko-dbs-location', action.payload)
  } else if (action.type === 'LOAD_PROJECT') {
    window.localStorage.setItem('peikko-dbs-location', action.payload.location)
  }
  if (action.type === '@@router/LOCATION_CHANGE') {
    let location = window.localStorage.getItem('peikko-dbs-location')
    if (location) {
      store.getState().project.location = location
      store.getState().project.defaultSpaceType = getDefaultSpaceType(location)
    }
  }

  return next(action)
}

export default function(history: History) {
  const middleware = [
    routerMiddleware(history),
    thunk,
    googleAnalytics,
    locationStorage
  ]
  const enhancers = []

  let composeEnhancers = compose

  if (process.env.NODE_ENV === 'development') {
    const composeWithDevToolsExtension =
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ // eslint-disable-line no-underscore-dangle
    if (typeof composeWithDevToolsExtension === 'function') {
      composeEnhancers = composeWithDevToolsExtension
    }
  }

  const store = createStore(
    createReducer({}),
    composeEnhancers(applyMiddleware(...middleware), ...enhancers)
  ) as AsyncStore<AppStore.Complete>

  store.asyncReducers = {}

  return store
}



// WEBPACK FOOTER //
// ./src/store/createStore.ts